import React from 'react';
import { useStoreActions, useStoreState } from 'easy-peasy';

import Headline from './Headline';
import Sharing from './Sharing';
import Infobox from './Infobox';

const Header = () => {
  const setInfoboxContent = useStoreActions(
    state => state.info.setInfoboxContent
  );
  const infoboxContent = useStoreState(state => state.info.infoboxContent);

  return (
    <>
      <Sharing setInfoboxContent={setInfoboxContent} />
      <Headline />
      <Infobox
        setInfoboxContent={setInfoboxContent}
        infoboxContent={infoboxContent}
      />
    </>
  );
};

export default Header;
